import styled from "styled-components";

export const TermsAndConditionsWrapper = styled.div`
  .button-edit-container {
    margin-bottom: 20px;
  }
`;
